export interface Solution {
  slug: string;
  name: string;
  tagline: string;
  intro: string;
  highlights: string[];
  bestFor: string[];
}

export const SOLUTIONS: Solution[] = [
  {
    slug: 'fraternities-sororities',
    name: 'Fraternities & Sororities',
    tagline: 'Honor tradition. Build lifelong bonds.',
    intro:
      'From the chapter room to national leadership, Konklave gives your Greek-letter organization a branded home that strengthens brotherhood and sisterhood across every generation.',
    highlights: [
      'A branded member directory that connects actives, alumni, and chapters',
      'Events, ticketing, and check-in for socials, philanthropy, and convention',
      'Dues collection, fundraising, and a marketplace for letters and merch',
      'Verification and profile claiming to protect your members and your name',
    ],
    bestFor: ['Undergraduate chapters', 'Alumni associations', 'Regional & national HQ'],
  },
  {
    slug: 'civic-organizations',
    name: 'Civic Organizations',
    tagline: 'Power local impact. Strengthen communities.',
    intro:
      'Service clubs, advocacy groups, and community organizations run on engagement. Konklave keeps members connected and mobilized around the work that matters.',
    highlights: [
      'A home feed and newsletters that keep members informed and inspired',
      'Events and volunteer sign-ups that make showing up easy',
      'Surveys, polls, and secure voting for member-led decisions',
      'Dues and fundraising tools to sustain your mission',
    ],
    bestFor: ['Service clubs', 'Advocacy & community groups', 'Local & regional councils'],
  },
  {
    slug: 'alumni-chapters',
    name: 'Alumni Chapters',
    tagline: 'Stay connected. Pay it forward.',
    intro:
      'Keep graduates engaged for life. Konklave helps alumni chapters maintain connection, host gatherings, and rally support long after members cross the stage.',
    highlights: [
      'A lifelong directory that keeps alumni findable and reachable',
      'Reunions, networking events, and ticketing in one place',
      'Newsletters and a community feed to share milestones and news',
      'Fundraising and dues to fuel scholarships and chapter programs',
    ],
    bestFor: ['University alumni chapters', 'Affinity & class networks', 'Foundations'],
  },
  {
    slug: 'national-organizations',
    name: 'National Organizations',
    tagline: 'Lead with purpose. Serve every member.',
    intro:
      'Unify every layer of your organization. Konklave connects members, chapters, regions, and national leadership in one platform, each with the right branding, access, and oversight.',
    highlights: [
      'One platform spanning members → chapters → regions → national leadership',
      'Multi-tenant branding so every level reflects its own identity',
      'Org-wide communication, voting, and reporting with role-based access',
      'Centralized dues, fundraising, and events with local autonomy',
    ],
    bestFor: ['National & international HQ', 'Regions & councils', 'Multi-chapter networks'],
  },
];

export const getSolution = (slug?: string) => SOLUTIONS.find((s) => s.slug === slug);
